import React, { useState } from 'react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { CheckCircle, Copy, Check, MessageSquare, Smartphone, FileText, AlertCircle, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export function TwilioCompliancePage() {
  const [copied, setCopied] = useState(false);
  const phoneNumber = '(774) 472-7423';
  const smsHref = `sms:+1${phoneNumber.replace(/\D/g, '')}?body=Hi%20ScribeTok!%20I%20want%20to%20transcribe%20a%20video.`;
  const handleCopyNumber = () => {
    navigator.clipboard.writeText(phoneNumber);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <div className="min-h-screen w-full bg-background p-4 sm:p-6 md:p-8 flex flex-col items-center overflow-x-hidden" data-id="element-1458">
      <div className="max-w-3xl w-full mx-auto" data-id="element-1459">
        {/* Logo */}
        <div className="flex justify-center mb-6" data-id="element-1460">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6tsscMEhsZ3L4JwT2r374e/ScribeTok-logo.png" alt="ScribeTok Logo" className="h-14 w-auto" data-id="element-1461" />
        </div>
        <header className="text-center mb-8" data-id="element-1462">
          <h1 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-1463">
            <span className="text-primary" data-id="element-1464">ScribeTok</span> SMS Service
          </h1>
          <p className="text-lg text-muted-foreground" data-id="element-1465">
            Terms of Use & Service Information
          </p>
        </header>
        <Card className="mb-8" data-id="element-1466">
          <CardContent className="p-6 md:p-8" data-id="element-1467">
            <div className="flex flex-col md:flex-row items-center gap-6 mb-8" data-id="element-1468">
              <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1469">
                <Smartphone size={32} className="text-primary" data-id="element-1470" />
              </div>
              <div data-id="element-1471">
                <h2 className="text-2xl font-semibold mb-2" data-id="element-1472">Our SMS Number</h2>
                <p className="text-muted-foreground mb-4" data-id="element-1473">
                  Text any TikTok or YouTube link to this number to receive an
                  instant transcript.
                </p>
                <div className="flex items-center gap-2 px-4 py-2 bg-secondary rounded-full cursor-pointer w-fit hover:bg-secondary/80 transition-colors" onClick={handleCopyNumber} data-id="element-1474">
                  <span className="font-medium" data-id="element-1475">{phoneNumber}</span>
                  {copied ? <Check size={16} className="text-green-500" data-id="element-1476" /> : <Copy size={16} data-id="element-1477" />}
                </div>
              </div>
            </div>
            <div className="space-y-6" data-id="element-1478">
              <section data-id="element-1479">
                <h3 className="text-xl font-medium mb-3 flex items-center" data-id="element-1480">
                  <MessageSquare size={18} className="text-primary mr-2" data-id="element-1481" />
                  SMS Opt-In Consent
                </h3>
                <div className="bg-secondary/30 p-4 rounded-lg border border-border" data-id="element-1482">
                  <p className="mb-2 font-medium" data-id="element-1483">
                    By texting our number ({phoneNumber}), you agree to:
                  </p>
                  <ul className="space-y-2 text-muted-foreground" data-id="element-1484">
                    <li className="flex items-start gap-2" data-id="element-1485">
                      <CheckCircle size={16} className="text-primary mt-1 flex-shrink-0" data-id="element-1486" />
                      <span data-id="element-1487">
                        Receive automated reply messages containing transcripts
                        and related information
                      </span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-1488">
                      <CheckCircle size={16} className="text-primary mt-1 flex-shrink-0" data-id="element-1489" />
                      <span data-id="element-1490">
                        Standard message and data rates may apply based on your
                        cellular plan
                      </span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-1491">
                      <CheckCircle size={16} className="text-primary mt-1 flex-shrink-0" data-id="element-1492" />
                      <span data-id="element-1493">
                        You can opt out at any time by replying STOP to any
                        message
                      </span>
                    </li>
                  </ul>
                </div>
              </section>
              <section data-id="element-1494">
                <h3 className="text-xl font-medium mb-3" data-id="element-1495">How It Works</h3>
                <ol className="space-y-4" data-id="element-1496">
                  <li className="flex items-start gap-3" data-id="element-1497">
                    <div className="w-6 h-6 rounded-full bg-primary/20 flex items-center justify-center text-primary flex-shrink-0 mt-0.5" data-id="element-1498">
                      1
                    </div>
                    <div data-id="element-1499">
                      <p className="font-medium" data-id="element-1500">Text a video link</p>
                      <p className="text-sm text-muted-foreground" data-id="element-1501">
                        Send any TikTok or YouTube URL to {phoneNumber}
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1502">
                    <div className="w-6 h-6 rounded-full bg-primary/20 flex items-center justify-center text-primary flex-shrink-0 mt-0.5" data-id="element-1503">
                      2
                    </div>
                    <div data-id="element-1504">
                      <p className="font-medium" data-id="element-1505">Wait a moment</p>
                      <p className="text-sm text-muted-foreground" data-id="element-1506">
                        Our AI processes the video and extracts the text
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1507">
                    <div className="w-6 h-6 rounded-full bg-primary/20 flex items-center justify-center text-primary flex-shrink-0 mt-0.5" data-id="element-1508">
                      3
                    </div>
                    <div data-id="element-1509">
                      <p className="font-medium" data-id="element-1510">Get your transcript</p>
                      <p className="text-sm text-muted-foreground" data-id="element-1511">
                        Receive the complete transcript via SMS
                      </p>
                    </div>
                  </li>
                </ol>
              </section>
              <section data-id="element-1512">
                <h3 className="text-xl font-medium mb-3 flex items-center" data-id="element-1513">
                  <FileText size={18} className="text-primary mr-2" data-id="element-1514" />
                  SMS Commands
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1515">
                  <div className="p-4 bg-secondary/30 rounded-lg border border-border" data-id="element-1516">
                    <p className="font-medium mb-1" data-id="element-1517">STOP</p>
                    <p className="text-sm text-muted-foreground" data-id="element-1518">
                      Opt out of all messages
                    </p>
                  </div>
                  <div className="p-4 bg-secondary/30 rounded-lg border border-border" data-id="element-1519">
                    <p className="font-medium mb-1" data-id="element-1520">HELP</p>
                    <p className="text-sm text-muted-foreground" data-id="element-1521">
                      Get information about the service
                    </p>
                  </div>
                  <div className="p-4 bg-secondary/30 rounded-lg border border-border" data-id="element-1522">
                    <p className="font-medium mb-1" data-id="element-1523">/vault</p>
                    <p className="text-sm text-muted-foreground" data-id="element-1524">
                      View your recent transcriptions
                    </p>
                  </div>
                  <div className="p-4 bg-secondary/30 rounded-lg border border-border" data-id="element-1525">
                    <p className="font-medium mb-1" data-id="element-1526">/summary</p>
                    <p className="text-sm text-muted-foreground" data-id="element-1527">
                      Get a condensed version of your transcript
                    </p>
                  </div>
                </div>
              </section>
              <section data-id="element-1528">
                <h3 className="text-xl font-medium mb-3 flex items-center" data-id="element-1529">
                  <AlertCircle size={18} className="text-primary mr-2" data-id="element-1530" />
                  Important Information
                </h3>
                <div className="space-y-3 text-muted-foreground" data-id="element-1531">
                  <p data-id="element-1532">
                    ScribeTok is a utility service that only sends messages in
                    direct response to user requests. We do not send promotional
                    or marketing messages.
                  </p>
                  <p data-id="element-1533">
                    Message frequency depends on your usage. We only respond
                    when you text us a video link or use one of our commands.
                  </p>
                  <p data-id="element-1534">
                    Your carrier's message and data rates may apply. Contact
                    your wireless provider for details about your plan.
                  </p>
                  <p data-id="element-1535">
                    For support issues, please contact us at
                    support@scribetok.com or visit our website.
                  </p>
                </div>
              </section>
            </div>
          </CardContent>
        </Card>
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8" data-id="element-1536">
          <a href={smsHref} data-id="element-1537">
            <Button size="lg" className="w-full sm:w-auto" data-id="element-1538">
              <MessageSquare size={16} className="mr-2" data-id="element-1539" />
              Text Now
            </Button>
          </a>
          <Link to="/text" data-id="element-1540">
            <Button variant="outline" size="lg" className="w-full sm:w-auto" data-id="element-1541">
              Back to Main Page
              <ArrowRight size={16} className="ml-2" data-id="element-1542" />
            </Button>
          </Link>
        </div>
        <footer className="text-center text-sm text-muted-foreground" data-id="element-1543">
          <p className="mb-2" data-id="element-1544">
            By using our service, you agree to our{' '}
            <a href="#" className="text-primary hover:underline" data-id="element-1545">
              Terms of Service
            </a>{' '}
            and{' '}
            <a href="#" className="text-primary hover:underline" data-id="element-1546">
              Privacy Policy
            </a>
            .
          </p>
          <p data-id="element-1547">© {new Date().getFullYear()} ScribeTok. All rights reserved.</p>
        </footer>
      </div>
    </div>;
}